/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_Replace_ListsInputs */

const en_auto_replace_lists = /** @type {(inputs: Auto_Replace_ListsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto Replace Lists`)
};

const fr_auto_replace_lists = /** @type {(inputs: Auto_Replace_ListsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listes de remplacement automatique`)
};

const de_auto_replace_lists = /** @type {(inputs: Auto_Replace_ListsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Ersetzungslisten`)
};

const it_auto_replace_lists = /** @type {(inputs: Auto_Replace_ListsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elenchi di sostituzione automatica`)
};

const ru_auto_replace_lists = /** @type {(inputs: Auto_Replace_ListsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Списки автоматической замены`)
};

const es_auto_replace_lists = /** @type {(inputs: Auto_Replace_ListsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listas de reemplazo automático`)
};

const zh_cn2_auto_replace_lists = /** @type {(inputs: Auto_Replace_ListsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动替换列表`)
};

const ja_auto_replace_lists = /** @type {(inputs: Auto_Replace_ListsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動置換リスト`)
};

const hi_auto_replace_lists = /** @type {(inputs: Auto_Replace_ListsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑटो रिप्लेस सूचियाँ`)
};

const pt_pt2_auto_replace_lists = /** @type {(inputs: Auto_Replace_ListsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listas de Substituição Automática`)
};

/**
* | output |
* | --- |
* | "Auto Replace Lists" |
*
* @param {Auto_Replace_ListsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_replace_lists = /** @type {((inputs?: Auto_Replace_ListsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_Replace_ListsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_auto_replace_lists(inputs)
	if (locale === "de") return de_auto_replace_lists(inputs)
	if (locale === "it") return it_auto_replace_lists(inputs)
	if (locale === "ru") return ru_auto_replace_lists(inputs)
	if (locale === "es") return es_auto_replace_lists(inputs)
	if (locale === "zh-CN") return zh_cn2_auto_replace_lists(inputs)
	if (locale === "ja") return ja_auto_replace_lists(inputs)
	if (locale === "hi") return hi_auto_replace_lists(inputs)
	if (locale === "pt-PT") return pt_pt2_auto_replace_lists(inputs)
	return en_auto_replace_lists(inputs)
});